// extracted by mini-css-extract-plugin
export default {"banner":"offline-banner_banner__Pk1Fd","dot":"offline-banner_dot__YyhSy","pulse":"offline-banner_pulse__85hJe"};